import axios, { type AxiosResponse } from 'axios';
import { getUpdateSessionEndpoint } from '@/api/helpers/get-update-session-endpoint';
import { AW_COOKIE } from '@/utilities/constants/metadata';

const GAME_SWITCH_TIMEOUT_MS = 5000;

export type UpdateGameSwitchSessionParams = {
  userId: string;
  gameUid: string;
  jackpotMode: boolean;
  token: string;
};

/**
 * Best-effort session reconciliation after a game switch. Throws on failure so
 * the caller's useMutation retry/onError handles backoff and swallowing — a
 * game switch must never be blocked by this call.
 */
export const updateGameSwitchSession = async ({
  userId,
  gameUid,
  jackpotMode,
  token,
}: UpdateGameSwitchSessionParams): Promise<AxiosResponse> => {
  const endpoint = getUpdateSessionEndpoint();

  if (!endpoint) {
    throw new Error(
      '[GW][GAME_SWITCH]: Unable to resolve the update-session endpoint',
    );
  }

  // Plain axios instance on purpose: unlike FabricServicesAxios it sends no
  // Cache-Control headers, which this endpoint does not need.
  const instance = axios.create({ timeout: GAME_SWITCH_TIMEOUT_MS });

  return instance.post(
    endpoint,
    {
      requestId: crypto.randomUUID(),
      userId,
      gamingSessionUpdates: { gameUid, jackpotMode },
    },
    {
      headers: { [AW_COOKIE.AUTH_TOKEN]: token },
    },
  );
};
